import { UsersListGridData, UsersListPersistedPagination } from './users-list.models';

export function getPaginationPage(pagination: UsersListPersistedPagination): number {
  if (pagination.page) {
    return pagination.page;
  }
  return Math.floor(pagination.firstRowOffset / pagination.pageSize) + 1;
}

export function getMatchingGridData(
  gridData: UsersListGridData | null,
  pagination: UsersListPersistedPagination,
  requestedPage: number
): UsersListGridData | null {
  if (!gridData || getPaginationPage(pagination) !== requestedPage) {
    return null;
  }
  return gridData;
}
